/*
Overview
-----
These are the site-specific CSS variables for Apartment Therapy's website. Sections are:

/* #SITE */
export const siteErrorImage =
  'https://cdn.apartmenttherapy.info/image/fetch/q_auto,f_auto,fl_strip_profile/https://s3.amazonaws.com/pixtruder/original_images/deed907c51f1f1d759c5753d16c9a4ac5c473091';

/* #COLOR */
export const colorPalette = {
  blue: '#80a6d4',
  brand: '#f12330',
  brightOrange: '#ff4b2e',
  gold: '#f0ba7d',
  lilac: '#e7d2db',
  lilacPink: '#f8c7f1',
  mellowYellow: '#ffe98f',
  mint: '#cfe8df',
  orange: '#f17245',
  peach: '#feeee6',
  red: '#f12330',
  salmon: '#ffc1b6',
  teal: '#3c94a0',
  violet: '#f7c4fa',
  yellow: '#fddd87',
  white: '#fff',
  black: '#000',
  gray: '#999',
  apartmentTherapy: '#f12330',
  kitchn: '#fff100',
  email: '#f0ba7d',
  facebook: '#3b5998',
  instagram: '#724bc5',
  pinterest: '#cb2128',
  saveStory: '#ff4b2e',
  twitter: '#1da1f2',
  youtube: '#ff0000'
};

export const colorHighlight = colorPalette.brightOrange;

export const grayBackground = '#f7f7f7';
export const grayLighter = '#ddd';
export const grayLightest = '#efefef';
export const grayDarker = '#666';
export const grayDarkest = '#333';

/* SIZES */

// The max width of the main "content" of any page
export const pageWidth = {
  small: '100vw',
  large: '976px',
  midlarge: '1148px', // Temporary name for transitioning
  xlarge: '1318px'
};

/* #FONTS */
export const serif =
  'Palatino, Palatino Linotype, Palatino LT STD, Book Antiqua, Georgia, serif';
export const sansSerif =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif";
export const verdana = 'Verdana, Geneva, sans-serif';
export const display =
  "'Playfair Display', Palatino, Palatino Linotype, Palatino LT STD, Book Antiqua, Georgia, serif";

export const baseFontSize = '16px';
